<template>
  <div class="section section4">
    <div class="section-con">
      <img
        :src="emptyImage"
        class="fullpage-item-holder"
        style="display: inline;"
      />
      <ul class="bg-list">
        <li
          v-for="(item, index) in tabList"
          :key="index"
          :class="{ cur: index === curBg }"
        >
          <div class="bgb" :class="['bg' + (index + 1)]">
            <!-- <span class="bgz"></span> -->
            <div class="bgs" :class="['bgs' + bgsInd]"></div>
          </div>
        </li>
      </ul>
      <div class="content-pos">
        <div class="main-con">
          <div class="box">
            <div class="information-nav">
              <ul class="information-box up-ani">
                <li
                  v-for="(item, index) in tabList"
                  :key="index"
                  class="infor-item"
                  :class="{ active: curBg === index }"
                  @click="changeTab(index)"
                >
                  {{ item.name }}
                </li>
              </ul>
            </div>
            <div class="section4-swiper" :class="['swiper-sec' + (curBg + 1)]">
              <swiper
                ref="inforSwiper"
                :key="swiperVisible"
                class="swiper"
                :options="swiperOption"
              >
                <swiper-slide
                  v-for="(item, index) in tabList[curBg].num"
                  :key="index"
                >
                  <div class="infor-slide">
                    <div
                      class="infor-msg fl"
                      :class="['infor-msg' + (index + 1)]"
                    ></div>
                    <div
                      class="infor-img fl"
                      :class="['infor-img' + (index + 1)]"
                    ></div>
                    <div
                      class="infor-t fl"
                      :class="['infor-t' + (index + 1)]"
                    ></div>
                  </div>
                </swiper-slide>
                <div
                  class="inforPagination"
                  :class="['inforPagination' + (curBg + 1)]"
                >
                  <div
                    slot="pagination"
                    class="swiper-pagination swiper-pagination-bullets"
                  ></div>
                </div>
                <div slot="button-prev" class="swiper-button-prev"></div>
                <div slot="button-next" class="swiper-button-next"></div>
              </swiper>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getEmptySVG } from "@/libs/svg";
import utils from "@/libs/utils";
const _hmt = window._hmt;
let vm = null;
export default {
  name: "Section4",
  data() {
    return {
      curBg: 0, // 当前切换
      tabList: [
        {
          name: "雷欧尼斯",
          num: 5
        },
        {
          name: "霍伦",
          num: 4
        },
        {
          name: "维泽特",
          num: 3
        },
        {
          name: "芬尼斯",
          num: 3
        },
        {
          name: "水晶教会",
          num: 4
        }
      ],
      swiperVisible: true,
      swiperOption: {
        allowTouchMove: false,
        loop: true,
        effect: "fade",
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        on: {
          slideChangeTransitionStart: function() {
            vm.bgsInd = this.activeIndex;
          }
        }
      },
      bgsInd: "",
      emptyImage: getEmptySVG(1920, 1080)
    };
  },
  computed: {
    ...mapState([""])
  },
  created() {
    vm = this;
  },
  methods: {
    changeTab(ind) {
      // 重新渲染轮播图
      this.swiperVisible = !this.swiperVisible;
      this.curBg = ind;
      _hmt.push([
        "_trackEvent",
        "page4",
        "changePeo" + ind,
        utils.checkRealOperaSys()
      ]);
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import "../assets/css/mixin.less";
.section4 {
  position: relative;
  .swiper-container {
    height: 100%;
    overflow: inherit;
  }
  .content-pos {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
    display: flex;
    justify-content: center;
  }
  .main-con {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .box {
    .mixin_com(height, 1050);
  }
  .information-nav {
    position: relative;
    z-index: 6;
    .mixin_com(width, 1240);

    height: auto;
    margin: 0 auto;
    .mixin_com(margin-top, 75);
    .mixin_com(margin-bottom, 75);
    .information-box {
      display: flex;
      justify-content: space-between;
      width: 100%;
      height: 100%;
    }
    .infor-item {
      .mixin_com(width, 187);
      .mixin_com(height, 48);

      text-indent: -9999px;
      cursor: pointer;
    }
    .Loop(@index) when(@index < 6) {
      li:nth-child(@{index}) {
        @imgUrl: "~@/assets/images/section4/i@{index}.png";
        @imgUrlH: "~@/assets/images/section4/i@{index}h.png";

        background: url("@{imgUrl}") no-repeat center top / cover;
        &.active,
        &:hover {
          background: url("@{imgUrlH}") no-repeat center top / cover;
        }
      }
      .Loop(@index+1);
    }
    .Loop(1);
  }
  .bg-list {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    li {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      .bgb {
        width: 100%;
        height: 100%;
        .animation(otherImgBg 1s forwards);
      }
      &.cur {
        z-index: 1;
        .bgb {
          .animation(curImgBg 1s forwards);
        }
      }
    }
    .Loop(@index) when(@index < 6) {
      li:nth-child(@{index}) {
        @imgUrl: "~@/assets/images/section4/bg@{index}.jpg";
        @imgUrls: "~@/assets/images/section4/bgs1@{index}.png";
        .bgb {
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          background: url("@{imgUrl}") no-repeat center top / cover;
        }
      }
      .Loop(@index+1);
    }
    .Loop(1);
    .bgs {
      .mixin_com(width, 1920);

      opacity: 0;
    }
    .bg1,
    .bg2,
    .bg3,
    .bg4,
    .bg5 {
      .bgs {
        opacity: 1;
        transition: all 0.6s;
        transition-delay: 0.2s;
      }
    }
    .bg1 {
      .Loop(@index) when(@index < 6) {
        .bgs@{index} {
          @imgUrls: "~@/assets/images/section4/ren/bgs1@{index}.png";

          background: url("@{imgUrls}") no-repeat center top / 100%;
        }
        .Loop(@index+1);
      }
      .Loop(1);
      .bgs1,
      .bgs6 {
        background:
          url("~@/assets/images/section4/ren/bgs11.png") no-repeat
          center top / 100%;
      }
      .bgs0,
      .bgs5 {
        background:
          url("~@/assets/images/section4/ren/bgs15.png") no-repeat
          center top / 100%;
      }
      .bgs {
        .mixin_com(height, 829);
        .mixin_com(margin-top, 55);
      }
    }
    .bg2 {
      .Loop(@index) when(@index < 5) {
        .bgs@{index} {
          @imgUrls: "~@/assets/images/section4/ren/bgs2@{index}.png";

          background: url("@{imgUrls}") no-repeat center top / 100%;
        }
        .Loop(@index+1);
      }
      .Loop(1);
      .bgs1,
      .bgs5 {
        background:
          url("~@/assets/images/section4/ren/bgs21.png") no-repeat
          center top / 100%;
      }
      .bgs0,
      .bgs4 {
        background:
          url("~@/assets/images/section4/ren/bgs24.png") no-repeat
          center top / 100%;
      }
      .bgs {
        .mixin_com(height, 536);
        .mixin_com(margin-top, 225);
      }
    }
    .bg3 {
      .Loop(@index) when(@index < 4) {
        .bgs@{index} {
          @imgUrls: "~@/assets/images/section4/ren/bgs3@{index}.png";

          background: url("@{imgUrls}") no-repeat center top / 100%;
        }
        .Loop(@index+1);
      }
      .Loop(1);
      .bgs1,
      .bgs4 {
        background:
          url("~@/assets/images/section4/ren/bgs31.png") no-repeat
          center top / 100%;
      }
      .bgs0,
      .bgs3 {
        background:
          url("~@/assets/images/section4/ren/bgs33.png") no-repeat
          center top / 100%;
      }
      .bgs {
        .mixin_com(height, 645);
        .mixin_com(margin-top, 115);
      }
    }
    .bg4 {
      .Loop(@index) when(@index < 4) {
        .bgs@{index} {
          @imgUrls: "~@/assets/images/section4/ren/bgs4@{index}.png";

          background: url("@{imgUrls}") no-repeat center top / 100%;
        }
        .Loop(@index+1);
      }
      .Loop(1);
      .bgs1,
      .bgs4 {
        background:
          url("~@/assets/images/section4/ren/bgs41.png") no-repeat
          center top / 100%;
      }
      .bgs0,
      .bgs3 {
        background:
          url("~@/assets/images/section4/ren/bgs43.png") no-repeat
          center top / 100%;
      }
      .bgs {
        .mixin_com(height, 645);
        .mixin_com(margin-top, 125);
      }
    }
    .bg5 {
      .Loop(@index) when(@index < 5) {
        .bgs@{index} {
          @imgUrls: "~@/assets/images/section4/ren/bgs5@{index}.png";

          background: url("@{imgUrls}") no-repeat center top / 100%;
        }
        .Loop(@index+1);
      }
      .Loop(1);
      .bgs1,
      .bgs5 {
        background:
          url("~@/assets/images/section4/ren/bgs51.png") no-repeat
          center top / 100%;
      }
      .bgs0,
      .bgs4 {
        background:
          url("~@/assets/images/section4/ren/bgs54.png") no-repeat
          center top / 100%;
      }
      .bgs {
        .mixin_com(height, 725);
        .mixin_com(margin-top, 144);
      }
    }
  }

  .infor-slide {
    position: absolute;
    width: 100%;
    opacity: 0;
    .mixin_com(top, 15);
  }
  .section4-swiper {
    position: relative;
    z-index: 1;
    .mixin_com(width, 1475);

    height: 100%;
    margin: 0 auto;
    .swiper-slide-active {
      .infor-slide {
        opacity: 1;
      }
      .infor-img,
      .infor-msg {
        transform: translateX(0) translateZ(0);
      }
      .infor-msg {
        .mixin_bg_pos(0, 1);
      }
      .infor-t {
        position: relative;
        z-index: 1;
        transform: translateY(0) translateZ(0);
      }
    }
    .swiper-button-prev,
    .swiper-container-rtl .swiper-button-next {
      left: 0;
    }
    .swiper-button-next,
    .swiper-container-rtl .swiper-button-prev {
      right: 0;
    }
    .swiper-button-prev {
      background:
        url("~@/assets/images/left_arr.png") no-repeat center top /
        cover;
    }
    .swiper-button-next {
      background:
        url("~@/assets/images/right_arr.png") no-repeat center top /
        cover;
    }
    .swiper-button-next::after,
    .swiper-container-rtl .swiper-button-prev::after {
      content: "";
    }
    .swiper-button-prev::after,
    .swiper-container-rtl .swiper-button-next::after {
      content: "";
    }
    .swiper-button-prev.swiper-button-disabled,
    .swiper-button-next.swiper-button-disabled {
      opacity: 1;
    }
    .swiper-button-prev,
    .swiper-button-next {
      top: 23%;
      .mixin_com(width, 55);
      .mixin_com(height, 75);
    }
  }
  .infor-img {
    transition: transform 0.5s;
    // transform: translateX(100px) translateZ(0);
    .mixin_trans(100);
  }
  .infor-msg {
    position: relative;
    z-index: 1;
    .mixin_com(height, 582);

    transition: transform 0.5s;
    // transform: translateX(-100px) translateZ(0);
    .mixin_trans(-100);
  }
  .infor-t {
    transition: transform 0.5s;
    // transform: translateY(-100px) translateZ(0);
    .mixin_transY(-100);
  }
  .swiper-sec1 {
    animation: fadeIn 1s linear forwards;
    .Loop(@index) when(@index < 6) {
      .infor-t@{index} {
        @imgUrls: "~@/assets/images/section4/ren/d1/pt1@{index}.png";

        background: url("@{imgUrls}") no-repeat left top / cover;
      }
      .infor-img@{index} {
        background:
          url("~@/assets/images/section4/ren/d1/pr1@{index}.png")
          no-repeat left top / cover;
      }
      .infor-msg@{index} {
        background:
          url("~@/assets/images/section4/ren/d1/pi1@{index}.png")
          no-repeat 0 center / cover;
      }
      .Loop(@index+1);
    }
    .Loop(1);
    .infor-t1 {
      .mixin_com(width, 140);
      .mixin_com(height, 728);
      .mixin_com(margin-top, 20);
      .mixin_com(margin-left, 5);
    }
    .infor-img1 {
      .mixin_com(width, 526);
      .mixin_com(height, 833);
      .mixin_com(margin-top, -20);
      .mixin_com(margin-left, 18);
    }
    .infor-msg1 {
      .mixin_com(width, 559);
      .mixin_com(margin-top, 24);
      .mixin_com(margin-left, 92);
    }
    .infor-t2 {
      .mixin_com(width, 76);
      .mixin_com(height, 677);
      .mixin_com(margin-top, 9);
      .mixin_com(margin-left, -164);
    }
    .infor-img2 {
      .mixin_com(width, 775);
      .mixin_com(height, 888);
      .mixin_com(margin-top, -38);
      .mixin_com(margin-left, -84);
    }
    .infor-msg2 {
      .mixin_com(width, 622);
      .mixin_com(margin-top, 24);
      .mixin_com(margin-left, 94);
    }
    .infor-t3 {
      .mixin_com(width, 70);
      .mixin_com(height, 485);
      .mixin_com(margin-top, 109);
      .mixin_com(margin-left, 70);
    }
    .infor-img3 {
      .mixin_com(width, 357);
      .mixin_com(height, 851);
      .mixin_com(margin-top, -11);
      .mixin_com(margin-left, -31);
    }
    .infor-msg3 {
      .mixin_com(width, 692);
      .mixin_com(margin-top, 32);
      .mixin_com(margin-left, 94);
    }
    .infor-t4 {
      .mixin_com(width, 142);
      .mixin_com(height, 695);
      .mixin_com(margin-top, 34);
      .mixin_com(margin-left, -55);
    }
    .infor-img4 {
      .mixin_com(width, 662);
      .mixin_com(height, 869);
      .mixin_com(margin-top, -11);
      .mixin_com(margin-left, -46);
    }
    .infor-msg4 {
      .mixin_com(width, 554);
      .mixin_com(margin-top, 32);
      .mixin_com(margin-left, 94);
    }
    .infor-t5 {
      .mixin_com(width, 67);
      .mixin_com(height, 471);
      .mixin_com(margin-top, 43);
      .mixin_com(margin-left, -144);
    }
    .infor-img5 {
      .mixin_com(width, 664);
      .mixin_com(height, 901);
      .mixin_com(margin-top, -47);
      .mixin_com(margin-left, 13);
    }
    .infor-msg5 {
      .mixin_com(width, 586);
      .mixin_com(margin-top, 32);
      .mixin_com(margin-left, 94);
    }
  }
  .swiper-sec2 {
    animation: fadeIn 1s linear forwards;
    .Loop(@index) when(@index < 5) {
      .infor-t@{index} {
        @imgUrls: "~@/assets/images/section4/ren/d2/pt2@{index}.png";

        background: url("@{imgUrls}") no-repeat left top / cover;
      }
      .infor-img@{index} {
        background:
          url("~@/assets/images/section4/ren/d2/pr2@{index}.png")
          no-repeat left top / cover;
      }
      .infor-msg@{index} {
        background:
          url("~@/assets/images/section4/ren/d2/pi2@{index}.png")
          no-repeat 0 center / cover;
      }
      .Loop(@index+1);
    }
    .Loop(1);
    .infor-t1 {
      .mixin_com(width, 78);
      .mixin_com(height, 692);
      .mixin_com(margin-top, 71);
      .mixin_com(margin-left, 9);
    }
    .infor-img1 {
      .mixin_com(width, 591);
      .mixin_com(height, 840);
      .mixin_com(margin-top, 4);
      .mixin_com(margin-left, -84);
    }
    .infor-msg1 {
      .mixin_com(width, 597);
      .mixin_com(margin-top, 32);
      .mixin_com(margin-left, 96);
    }
    .infor-t2 {
      .mixin_com(width, 130);
      .mixin_com(height, 554);
      .mixin_com(margin-top, 112);
      .mixin_com(margin-left, -115);
    }
    .infor-img2 {
      .mixin_com(width, 802);
      .mixin_com(height, 867);
      .mixin_com(margin-top, -38);
      .mixin_com(margin-left, -138);
    }
    .infor-msg2 {
      .mixin_com(width, 561);
      .mixin_com(margin-top, 24);
      .mixin_com(margin-left, 94);
    }
    .infor-t3 {
      .mixin_com(width, 79);
      .mixin_com(height, 738);
      .mixin_com(margin-top, 11);
      .mixin_com(margin-left, 35);
    }
    .infor-img3 {
      .mixin_com(width, 441);
      .mixin_com(height, 877);
      .mixin_com(margin-top, -56);
      .mixin_com(margin-left, 18);
    }
    .infor-msg3 {
      .mixin_com(width, 552);
      .mixin_com(margin-top, 33);
      .mixin_com(margin-left, 94);
    }
    .infor-t4 {
      .mixin_com(width, 134);
      .mixin_com(height, 722);
      .mixin_com(margin-top, 1);
      .mixin_com(margin-left, -49);
    }
    .infor-img4 {
      .mixin_com(width, 469);
      .mixin_com(height, 869);
      .mixin_com(margin-top, -47);
      .mixin_com(margin-left, 4);
    }
    .infor-msg4 {
      .mixin_com(width, 662);
      .mixin_com(margin-top, 32);
      .mixin_com(margin-left, 94);
    }
  }
  .swiper-sec3 {
    animation: fadeIn 1s linear forwards;
    .Loop(@index) when(@index < 4) {
      .infor-t@{index} {
        @imgUrls: "~@/assets/images/section4/ren/d3/pt1@{index}.png";

        background: url("@{imgUrls}") no-repeat left top / cover;
      }
      .infor-img@{index} {
        background:
          url("~@/assets/images/section4/ren/d3/pr1@{index}.png")
          no-repeat left top / cover;
      }
      .infor-msg@{index} {
        background:
          url("~@/assets/images/section4/ren/d3/pi1@{index}.png")
          no-repeat 0 center / cover;
      }
      .Loop(@index+1);
    }
    .Loop(1);
    .infor-t1 {
      .mixin_com(width, 131);
      .mixin_com(height, 589);
      .mixin_com(margin-top, 113);
      .mixin_com(margin-left, -115);
    }
    .infor-img1 {
      .mixin_com(width, 676);
      .mixin_com(height, 1060);
      .mixin_com(margin-top, -224);
      .mixin_com(margin-left, -78);
    }
    .infor-msg1 {
      .mixin_com(width, 626);
      .mixin_com(margin-top, 32);
      .mixin_com(margin-left, 95);
    }
    .infor-t2 {
      .mixin_com(width, 79);
      .mixin_com(height, 741);
      .mixin_com(margin-top, 34);
      .mixin_com(margin-left, 58);
    }
    .infor-img2 {
      .mixin_com(width, 440);
      .mixin_com(height, 1061);
      .mixin_com(margin-top, -212);
      .mixin_com(margin-left, 34);
    }
    .infor-msg2 {
      .mixin_com(width, 581);
      .mixin_com(margin-top, 30);
      .mixin_com(margin-left, 95);
    }
    .infor-t3 {
      .mixin_com(width, 71);
      .mixin_com(height, 605);
      .mixin_com(margin-top, 102);
      .mixin_com(margin-left, -45);
    }
    .infor-img3 {
      .mixin_com(width, 553);
      .mixin_com(height, 1053);
      .mixin_com(margin-top, -210);
      .mixin_com(margin-left, -20);
    }
    .infor-msg3 {
      .mixin_com(width, 629);
      .mixin_com(margin-top, 32);
      .mixin_com(margin-left, 96);
    }
  }
  .swiper-sec4 {
    animation: fadeIn 1s linear forwards;
    .Loop(@index) when(@index < 4) {
      .infor-t@{index} {
        @imgUrls: "~@/assets/images/section4/ren/d4/pt1@{index}.png";

        background: url("@{imgUrls}") no-repeat left top / cover;
      }
      .infor-img@{index} {
        background:
          url("~@/assets/images/section4/ren/d4/pr1@{index}.png")
          no-repeat left top / cover;
      }
      .infor-msg@{index} {
        background:
          url("~@/assets/images/section4/ren/d4/pi1@{index}.png")
          no-repeat 0 center / cover;
      }
      .Loop(@index+1);
    }
    .Loop(1);
    .infor-t1 {
      .mixin_com(width, 141);
      .mixin_com(height, 704);
      .mixin_com(margin-top, 29);
      .mixin_com(margin-left, 30);
    }
    .infor-img1 {
      .mixin_com(width, 506);
      .mixin_com(height, 876);
      .mixin_com(margin-top, -44);
      .mixin_com(margin-left, -120);
    }
    .infor-msg1 {
      .mixin_com(width, 684);
      .mixin_com(margin-top, 32);
      .mixin_com(margin-left, 95);
    }
    .infor-t2 {
      .mixin_com(width, 77);
      .mixin_com(height, 386);
      .mixin_com(margin-top, 125);
      .mixin_com(margin-left, 658);
    }
    .infor-img2 {
      .mixin_com(width, 974);
      .mixin_com(height, 985);
      .mixin_com(left, 543);
      .mixin_com(top, -159);
    }
    .infor-msg2 {
      .mixin_com(width, 556);
      .mixin_com(margin-top, 30);
      .mixin_com(margin-left, 95);
    }
    .infor-t3 {
      .mixin_com(width, 114);
      .mixin_com(height, 630);
      .mixin_com(margin-top, 43);
      .mixin_com(margin-left, -76);
    }
    .infor-img3 {
      .mixin_com(width, 635);
      .mixin_com(height, 955);
      .mixin_com(margin-top, -133);
      .mixin_com(margin-left, -3);
    }
    .infor-msg3 {
      .mixin_com(width, 586);
      .mixin_com(margin-top, 32);
      .mixin_com(margin-left, 96);
    }
  }
  .swiper-sec5 {
    animation: fadeIn 1s linear forwards;
    .Loop(@index) when(@index < 5) {
      .infor-t@{index} {
        @imgUrls: "~@/assets/images/section4/ren/d5/pt1@{index}.png";

        background: url("@{imgUrls}") no-repeat left top / cover;
      }
      .infor-img@{index} {
        background:
          url("~@/assets/images/section4/ren/d5/pr1@{index}.png")
          no-repeat left top / cover;
      }
      .infor-msg@{index} {
        background:
          url("~@/assets/images/section4/ren/d5/pi1@{index}.png")
          no-repeat 0 center / cover;
      }
      .Loop(@index+1);
    }
    .Loop(1);
    .infor-t1 {
      .mixin_com(width, 74);
      .mixin_com(height, 595);
      .mixin_com(margin-top, 29);
      .mixin_com(margin-left, -70);
    }
    .infor-img1 {
      .mixin_com(width, 633);
      .mixin_com(height, 986);
      .mixin_com(margin-top, -130);
      .mixin_com(margin-left, -130);
    }
    .infor-msg1 {
      .mixin_com(width, 657);
      .mixin_com(margin-top, 32);
      .mixin_com(margin-left, 96);
    }
    .infor-t2 {
      .mixin_com(width, 74);
      .mixin_com(height, 595);
      .mixin_com(margin-top, 30);
      .mixin_com(margin-left, -284);
    }
    .infor-img2 {
      .mixin_com(width, 1031);
      .mixin_com(height, 904);
      .mixin_com(margin-top, -50);
      .mixin_com(margin-left, -320);
    }
    .infor-msg2 {
      .mixin_com(width, 665);
      .mixin_com(margin-top, 24);
      .mixin_com(margin-left, 94);
    }
    .infor-t3 {
      .mixin_com(width, 74);
      .mixin_com(height, 595);
      .mixin_com(margin-top, 29);
      .mixin_com(margin-left, -216);
    }
    .infor-img3 {
      .mixin_com(width, 921);
      .mixin_com(height, 1070);
      .mixin_com(margin-top, -226);
      .mixin_com(margin-left, -268);
    }
    .infor-msg3 {
      .mixin_com(width, 653);
      .mixin_com(margin-top, 33);
      .mixin_com(margin-left, 94);
    }
    .infor-t4 {
      .mixin_com(width, 74);
      .mixin_com(height, 595);
      .mixin_com(margin-top, 30);
      .mixin_com(margin-left, -252);
    }
    .infor-img4 {
      .mixin_com(width, 981);
      .mixin_com(height, 1080);
      .mixin_com(margin-top, -227);
      .mixin_com(margin-left, -290);
    }
    .infor-msg4 {
      .mixin_com(width, 655);
      .mixin_com(margin-top, 32);
      .mixin_com(margin-left, 94);
    }
  }
  .section-con {
    height: 100% !important;
  }
}
</style>
<style lang="less">
@import "../assets/css/mixin.less";
.section4 {
  .swiper-pagination {
    .mixin_com(width, 500);
    .mixin_com(margin-left, 80);

    text-align: left;
  }
  .swiper-pagination-bullet {
    .mixin_com(width, 90);
    .mixin_com(height, 90);
    .mixin_com(margin-left, 12);

    opacity: 1;
    &:nth-child(1) {
      margin-left: 0;
    }
  }
  .inforPagination {
    position: absolute;
    .mixin_com(top, 642);
    .mixin_com(left, 120);
    .mixin_com(height, 90);
    .mixin_com(width, 500);
  }
  .inforPagination1 {
    .Loop(@index) when(@index < 6) {
      .swiper-pagination-bullet:nth-child(@{index}) {
        @imgUrln: "~@/assets/images/section4/ren/d1/psn1@{index}.png";
        @imgUrlh: "~@/assets/images/section4/ren/d1/ps1@{index}.png";

        background: url("@{imgUrln}") no-repeat center top / cover;
        &.swiper-pagination-bullet-active {
          background: url("@{imgUrlh}") no-repeat center top / cover;
        }
      }
      .Loop(@index+1);
    }
    .Loop(1);
  }
  .inforPagination2 {
    .Loop(@index) when(@index < 5) {
      .swiper-pagination-bullet:nth-child(@{index}) {
        @imgUrln: "~@/assets/images/section4/ren/d2/psn2@{index}.png";
        @imgUrlh: "~@/assets/images/section4/ren/d2/ps2@{index}.png";

        background: url("@{imgUrln}") no-repeat center top / cover;
        &.swiper-pagination-bullet-active {
          background: url("@{imgUrlh}") no-repeat center top / cover;
        }
      }
      .Loop(@index+1);
    }
    .Loop(1);
  }
  .inforPagination3 {
    .Loop(@index) when(@index < 4) {
      .swiper-pagination-bullet:nth-child(@{index}) {
        @imgUrln: "~@/assets/images/section4/ren/d3/psn1@{index}.png";
        @imgUrlh: "~@/assets/images/section4/ren/d3/ps1@{index}.png";

        background: url("@{imgUrln}") no-repeat center top / cover;
        &.swiper-pagination-bullet-active {
          background: url("@{imgUrlh}") no-repeat center top / cover;
        }
      }
      .Loop(@index+1);
    }
    .Loop(1);
  }
  .inforPagination4 {
    .Loop(@index) when(@index < 4) {
      .swiper-pagination-bullet:nth-child(@{index}) {
        @imgUrln: "~@/assets/images/section4/ren/d4/psn1@{index}.png";
        @imgUrlh: "~@/assets/images/section4/ren/d4/ps1@{index}.png";

        background: url("@{imgUrln}") no-repeat center top / cover;
        &.swiper-pagination-bullet-active {
          background: url("@{imgUrlh}") no-repeat center top / cover;
        }
      }
      .Loop(@index+1);
    }
    .Loop(1);
  }
  .inforPagination5 {
    .Loop(@index) when(@index < 5) {
      .swiper-pagination-bullet:nth-child(@{index}) {
        @imgUrln: "~@/assets/images/section4/ren/d5/psn1@{index}.png";
        @imgUrlh: "~@/assets/images/section4/ren/d5/ps1@{index}.png";

        background: url("@{imgUrln}") no-repeat center top / cover;
        &.swiper-pagination-bullet-active {
          background: url("@{imgUrlh}") no-repeat center top / cover;
        }
      }
      .Loop(@index+1);
    }
    .Loop(1);
  }
}
</style>
